import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { MenuContactsEffects } from './menu-contacts.effects';
import { menuContactsReducer } from './menu-contacts.reducer';
import { MENU_CONTACTS_FEATURE_KEY } from './menu-contacts.selectors';

export const provideMenuContacts = () => [provideState(MENU_CONTACTS_FEATURE_KEY, menuContactsReducer), provideEffects(MenuContactsEffects)];
